import { dateDiff } from "@/filters/DateAndTime";
import { patientNamespace } from "@/store/modules/patient";
import { CensusData } from "@/store/modules/patient/types";
import _ from "lodash";
import { Component, Prop, Vue } from "vue-property-decorator";
import { Getter } from "vuex-class";

@Component({})
export default class GridCardIcu extends Vue {
  MAX_ROOM_EMPTY_TIME = 5400;
  getAbbrev(caseStateIndex: number) {
    const caseStates = this.$store.getters["patient/caseState"];
    if (caseStates) {
      return caseStates[caseStateIndex].abbrev;
    }
    return null;
  }

  @Getter("vars", patientNamespace)
  vars!: any;

  @Getter("now", patientNamespace)
  now!: any;

  @Prop(Object)
  data!: CensusData;

  get bmiRisk(): boolean {
    return _.get(this, "data.atoms.bmi.value", 0) > 30;
  }

  get showEga(): boolean {
    return this.vars.caseState[this.data.caseState].stage < 4;
  }

  get los() {
    const losHours = dateDiff(this.data.admitDate, this.now, "hour");
    return losHours >= 24
      ? Math.round((losHours * 1.0) / 24.0)
      : Math.round(losHours) + " hr";
  }
}
